import { TFunction } from 'i18next'

export const TypeDocument = (t: TFunction) => [
    {
        value: 'POLICY', // Pre value CS
        label: t('document.type.policy'),
    },
    {
        value: 'INTERNAL_REGULATION', // Pre value QC/NQ
        label: t('document.type.internal_regulation'),
    },
    {
        value: 'REGULATION', // Pre value QD
        label: t('document.type.regulation'),
    },
    {
        value: 'GUIDELINE', // Pre value HD
        label: t('document.type.guideline'),
    },
    {
        value: 'FORM', // Pre value BM
        label: t('document.type.form'),
    },
    {
        value: 'OBJECTIVE', // Pre value MT
        label: t('document.type.objective'),
    },
    {
        value: 'NOTIFICATION', // Pre value TB
        label: t('document.type.notification'),
    },
    {
        value: 'PLAN', // Pre value KH
        label: t('document.type.plan'),
    },
    {
        value: 'REPORT', // Pre value BC
        label: t('document.type.report'),
    },
    {
        value: 'MINUTES', // Pre value BB
        label: t('document.type.minutes'),
    },
    {
        value: 'CONTRACT', // Pre value HĐ
        label: t('document.type.contract'),
    },
    {
        value: 'DECISION', // Pre value QĐ
        label: t('document.type.decision'),
    },
    {
        value: 'OTHER', // Pre value Khác
        label: t('document.type.other'),
    },
]
export const DocumentLevel = (t: TFunction) => [
    {
        value: 'CF', // Pre value CF
        label: t('document.level.cf'),
    },
    {
        value: 'LM', // Pre value LM
        label: t('document.level.lm'),
    },
    {
        value: 'IN', // Pre value IN
        label: t('document.level.in'),
    },
]
export const DepartmentDefineDocument = [
    {
        value: 'Board of Directors',
        label: 'BOARD OF DIRECTIONS',
    },
    {
        value: 'Development',
        label: 'DEVELOPMENT',
    },
    {
        value: 'Board of Management',
        label: 'BOARD OF MANAGEMENT',
    },
    {
        value: 'Account',
        label: 'ACCOUNT',
    },
    {
        value: 'Finance',
        label: 'FINANCE',
    },
    {
        value: 'Human Resource',
        label: 'HUMAN RESOURCE',
    },
    {
        value: 'Marketing',
        label: 'MARKETING',
    },
    {
        value: 'Sale Partner',
        label: 'SALE PARTNER',
    },
    {
        value: 'Sales',
        label: 'SALES',
    },
    {
        value: 'Technology',
        label: 'TECHNOLOGY',
    },
]

export const DocumentStatus = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'pending',
        label: 'Pending',
    },
]
export const DocumentStatusFilter = [
    {
        value: 'APPROVED',
        label: 'Approved',
    },
    {
        value: 'PENDING',
        label: 'Pending',
    },
    {
        value: 'REJECTED',
        label: 'Rejected',
    },
]
